import React from "react";
import Navbar from "../Components/Navbar";
import Cropcountheader from "../Components/Cropcountheader";
import CropCountmap from "../Components/map/CropCountmap";

function Cropcount(props) {
    return (
        <div className="h-screen flex flex-col ">
            <div className="w-full h-full flex flex-col ">
                <Navbar />
                <Cropcountheader heading='India State Crop Statistics' />
                <CropCountmap />
            </div>
            <p  className="text-center text-xs font-bold">
                Powered by NIRUTHI ©
            </p>
        </div>
    );
}

export default Cropcount;
